module.exports = __webpack_public_path__ + "img/WorldBuildingNewsScreenFrame.6f89e389.png";